import React, {useState, useLayoutEffect} from "react"

export default function Radio({json, dependencies, onFieldChange})
{         
    const [selected, setSelected] = useState('')
    
    const update = (e) =>
    {
        const value = e.target.value
        setSelected(value)
        if(dependencies) dependencies(json.key, value, e.target)
    }

    const change = (e) =>
    {
        const value = e.currentTarget.dataset.value
        setSelected(value)
        if(dependencies) dependencies(json.key, value, e.currentTarget)
        if(onFieldChange) onFieldChange(json.key, value, e.currentTarget)
    }

    useLayoutEffect(()=>
    {       
       setSelected(json.options[0][0])
       if(dependencies) dependencies(json.key, json.options[0][0])
       if(onFieldChange) onFieldChange(json.key, json.options[0][0])

    },[])

    return (
        <div className="json-input radio">
            {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
            <div className="options">
            {
                json.options.map((option) =>
                {                                        
                    return (
                        <div className="option" data-value={option[0]} onClick={change}>
                            <input type="radio" className={'input_'+json.key} name={json.key} value={option[0]} checked={selected === option[0]} onChange={update} /><label>{option[1]}</label>
                        </div>
                    )
                })   
            }
            </div>
        </div> 
    ) 
}